import { useState, useEffect } from 'react';
import { FeatureFlagsRepository } from '~/util/FeatureFlagsRepository';

/**
 * This hook will return the state of a `checkFeature` call, and will update when feature flags
 * change.
 */

export function useFeatureFlag<FeatureId extends string>(
  featureFlags: FeatureFlagsRepository<FeatureId>,
  feature: FeatureId,
): boolean {
  const [flag, setFlag] = useState( featureFlags.check( feature ) );

  useEffect( () => featureFlags.listen( () => setFlag( featureFlags.check( feature ) ) ), [featureFlags, feature] );

  return flag;
}
